import portfolio from "./Portfolio.pdf";

function App() {
  return (
    <div>
      <a href={portfolio} rel="noreferrer" download="Portfolio" target='_blank'>
        <button>Download portfolio</button>
      </a>
    </div>
  );
}

export default App;
